module.exports = "<mat-tab-group animationDuration=\"0ms\" class=\"admin-tab-container\">\n    <mat-tab label=\"Properties\">\n        <ng-template matTabContent>\n            <properties></properties>\n        </ng-template>\n    </mat-tab>\n    <mat-tab label=\"Agents\">\n        <ng-template matTabContent>\n            <agents></agents>\n        </ng-template>\n    </mat-tab>\n    <mat-tab label=\"Agent Cluster\">\n        <ng-template matTabContent>\n            <agent-cluster></agent-cluster>\n        </ng-template>\n    </mat-tab>\n</mat-tab-group>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/admin/admin.component.html
// module id = 1718
// module chunks = 0